// src/components/common/Textarea.jsx
// Reusable textarea component

import React from 'react';

const Textarea = ({
  label,
  icon,
  name,
  value,
  onChange,
  placeholder,
  error,
  required,
  disabled,
  rows = 4,
  maxLength,
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={name} className="block text-gray-700 font-semibold mb-1 dark:text-gray-200">
          {icon && <span className="mr-2">{icon}</span>}
          {label}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        className={`neumorphic-input w-full ${error ? 'border-red-400' : ''} ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        maxLength={maxLength}
        required={required}
        disabled={disabled}
      />
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
};

export default Textarea;
